import React from "react";
import styles from "./PageNotFound.module.scss";

const PageNotFound = () => {
  return <div className={styles.mainWrap}>PageNotFound</div>;
};

export default PageNotFound;
